<template>
  <b-card>
    <b-button
      class="text-center"
      variant="outline-primary"
      block
    >
      {{ title }}
    </b-button>
    <b-form-group
      v-for="(sentence, index) in shuffledSentences"
      :key="index"
    >
      <b-badge class="mt-5" variant="secondary">No.{{ index + 1 }}</b-badge>
      <b-progress
        class="my-3"
        :value="sentence.value"
        show-progress
        animated
      ></b-progress>
      <div class="border border-primary rounded p-3">
        <p>{{ sentence.translation }}</p>
        <p>
          <span
            class="sentence"
            v-for="(word, index) in sentence.selectedWords"
            :key="`selected-${index}`"
          >
            {{ "" + word.caption }}
          </span>
        </p>
      </div>
      <div class="my-3">
        <h5>{{ makeSentence }}</h5>
        <b-button
          v-b-popover.hover.top.html="puzzle.content"
          :title="puzzle.title"
          class="m-1"
          v-for="(puzzle, index) in sentence.puzzles"
          :key="`puzzle-${index}`"
          :pressed.sync="puzzle.state"
          variant="outline-dark"
          @click="select(puzzle, sentence)"
        >
          {{ puzzle.caption }}
        </b-button>
      </div>
      <b-button
        :disabled="sentence.disabled"
        variant="primary"
        class="float-left"
        @click="clear(sentence)"
      >
        Clear
      </b-button>
    </b-form-group>
  </b-card>
</template>

<script>
import { shuffle } from "@/utils/shuffle";
export default {
  name: "ReviewLesson",
  data() {
    return {
      sentence: {
        sentenceId: undefined,
        translation: undefined,
        words: [],
        puzzles: [],
        selectedWords: [],
        value: undefined,
        max: undefined,
        disabled: undefined
      },
      title: process.env.VUE_APP_REVIEW,
      shuffledSentences: [],
      makeSentence: process.env.VUE_APP_MAKE_SENTENCE
    };
  },
  props: {
    sentences: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    sentences: {
      handler(newVal) {
        if (Array.isArray(newVal) && newVal.length > 0) {
          this.shuffledSentences = this.shuffleSentences(newVal);
        }
      },
      immediate: true
    }
  },
  methods: {
    /** 根据选择的词进行判断，在进度棒上显示 */
    select(puzzle, sentence) {
      // 选择词的状态判断是增词还是删词
      if (puzzle.state) {
        sentence.selectedWords.push(puzzle);
      } else {
        let index = sentence.selectedWords.findIndex(obj => obj.id === puzzle.id)
        if (index !== -1) {
          sentence.selectedWords.splice(index, 1);
        }
      }
      let resultWords = [];
      // 生成选择的词数组
      for (const word of sentence.selectedWords) {
        resultWords.push(word.caption);
      }
      const index = resultWords.length;
      // 判断词数组是否清空，用于控制清空按钮
      sentence.disabled = (index <= 0);
      const words = sentence.words.slice(0, index);
      // 设定进程值
      if (this.arraysEqual(resultWords, words)) {
        sentence.value = index * 100 / sentence.max;
      }
    },
    /** 清零选择词和进度棒 */
    clear(sentence) {
      sentence.disabled = true;
      sentence.value = 0;
      sentence.selectedWords = [];
      // 初始化词数组的状态值
      sentence.puzzles = sentence.puzzles.map(item => ({ ...item, state: false }));
      this.shuffledSentences = this.shuffleSentences(this.sentences);
    },
    /** 比较字符串数组是否相等 */
    arraysEqual(a, b) {
      return JSON.stringify(a) === JSON.stringify(b);
    },
    /** 把句列表改变顺序，暂时只改变句子中词的顺序 */
    shuffleSentences(sentences) {
      const items = [];
      for (let sentence of sentences) {
        const item = {
          sentenceId: undefined,
          translation: undefined,
          words: [],
          puzzles: [],
          selectedWords: [],
          value: undefined,
          max: undefined,
          disabled: undefined
        };
        item.sentenceId = sentence.sentenceId;
        item.translation = sentence.translation;
        let temp = [];
        // 生成组成句子的词数组
        for (const [index, word] of [...sentence.words].entries()) {
          item.words.push(word.vocabulary);
          let obj = {
            id: index,
            caption: word.vocabulary,
            title: word.title,
            content: word.content,
            state: false
          };
          temp.push(obj);
        }
        // 随机改变词数组内词的顺序
        item.puzzles = shuffle(temp);
        // 进程值
        item.value = 0;
        item.max = item.words.length;
        item.disabled = true;
        items.push(item);
      }
      return items;
    }
  }
}
</script>

<style scoped>
.sentence {
  background-color: lightgray;
  font-size: 1.875em;
  color: royalblue;
}
</style>
